import React, { useEffect, useState } from "react";
import CuerpoPrincipal from "../elementos/basicos/CuerpoPrincipal";
import BotonesAccion from "../elementos/eventos/navegacion_y_accion/BotonesAccion";
import EnhancedTable from "../elementos/basicos/TablaCategoriasConvocatoria";
import { fetchCategoriasConvocatoriaFilters, fetchActualizarCategorias } from '../../peticiones_API/PeticionesCategoriaConvocatoria';
import { useLocation, useNavigate } from 'react-router-dom';

import IconosGenerales from "../elementos/iconos/IconosGenerales";
import Titulo from "../elementos/basicos/Titulo";
import styled from 'styled-components';
import Navbar from "../elementos/cuerpo/Navbar";
import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';

const GestorCategoriasConvocatoria = (props) => {

    

    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));

    let busqueda = params.get("busqueda") || null;
    let nivel = params.get("nivel");
    let numSubcategorias = params.get("numSubcategorias");
    let anexo = params.get("anexo");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(true);
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();
    const [data, setData] = useState({
        meta: {},
        rows: []
    });

    const [requisitos, setRequisitos] = useState();
    const [esAnexo, setEsAnexo] = useState();
    const [selected, setSelected] = useState([]);
    const [eliminarTodoCategorias, setEliminarTodoCategorias] = useState({ atributo: 'visible', valor: null });
    const [eliminarCatSelect, setEliminarCatSelect] = useState({ atributo: 'visible', valor: null });



    const confirmDialog = ConfirmacionEliminar();

    useEffect(() => {
        async function fechtActualizarFiltros() {
            console.log("Entra en el filtro");

            try {
                if (

                    eliminarTodoCategorias.valor == false ||
                    eliminarCatSelect.valor == false
                ) {
                    let mensaje = "";

                    if (eliminarTodoCategorias.valor === false || eliminarCatSelect.valor === false) {
                        mensaje = "eliminar";
                    }

                    const confirm = await confirmDialog.showAlert(mensaje,"categorias");

                    if (confirm) {
                        let categoriasActualizar = [];


                        if (eliminarTodoCategorias.valor === false) {
                            setEliminarTodoCategorias((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const categoriasResponse = await fetchCategoriasConvocatoriaFilters(
                                paginaActual,
                                registrosPorPag,
                                busqueda,
                                nivel,
                                anexo,
                                numSubcategorias,
                                ordenarColumna,
                                orden
                            );

                            categoriasResponse.data.forEach((categoria) => {
                                categoriasActualizar.push(categoria.Id);
                            });

                            console.log("Entra en condición de desactivar todos");
                            await fetchActualizarCategorias(categoriasActualizar, eliminarTodoCategorias);
                        }


                        if (eliminarCatSelect.valor == false && selected.length !== 0) {
                            setEliminarCatSelect((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            categoriasActualizar = selected;
                            console.log("eliminarCatSelect", eliminarCatSelect);
                            await fetchActualizarCategorias(categoriasActualizar, eliminarCatSelect);
                        }


                        const categoriasResponse = await fetchCategoriasConvocatoriaFilters(paginaActual, registrosPorPag, busqueda, nivel, anexo, numSubcategorias, ordenarColumna, orden);

                        const { data: categoriasData, meta } = categoriasResponse;

                        setData({
                            meta,
                            rows: formatData(categoriasData),
                        });

                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    } else {

                        setEliminarTodoCategorias((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setEliminarCatSelect((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error al actualizar filtros:", error);
            }
        }



        if (
            eliminarTodoCategorias.valor !== null ||
            eliminarCatSelect.valor !== null
        ) {
            fechtActualizarFiltros();
        }
    }, [eliminarTodoCategorias, eliminarCatSelect, paginaActual, registrosPorPag, anexo, nivel, numSubcategorias, busqueda, ordenarColumna, orden, selected]);


    useEffect(() => {
        async function fechtPrincipal() {
            try {


                if (!paginaActual || !registrosPorPag) {
                    const categoriasResponse = await fetchCategoriasConvocatoriaFilters(paginaActual, registrosPorPag);
                    const { data: categoriasData, meta } = categoriasResponse;
                    // console.log("categoriasResponse ",categoriasResponse);
                    paginaActual = meta.current_page;
                    registrosPorPag = meta.per_page;
                    navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    setData({
                        meta,
                        rows: formatData(categoriasData)
                    });
                } else {
                    let urlParams = `?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`;

                    if (busqueda !== null && busqueda !== '' && busqueda !== undefined) {
                        urlParams += `&busqueda=${busqueda}`;
                    }

                    if (nivel !== null) {
                        urlParams += `&nivel=${nivel}`;
                    }
                    if (anexo !== null) {
                        urlParams += `&anexo=${anexo}`
                    }
                    if (numSubcategorias !== null) {
                        urlParams += `&numSubcategorias=${numSubcategorias}`
                    }

                    if (ordenarColumna !== null) {
                        urlParams += `&ordenarColumna=${ordenarColumna}`;
                    }
                    if (orden !== null) {
                        urlParams += `&orden=${orden}`;
                    }
                    navigate(`${urlPadre}${urlParams}`);
                    const categoriasResponse = await fetchCategoriasConvocatoriaFilters(paginaActual, registrosPorPag, busqueda, nivel, anexo, numSubcategorias, ordenarColumna, orden);
                    console.log("categoriasResponse ", categoriasResponse);
                    const { data: categoriasData, meta } = categoriasResponse;
                    setData({
                        meta,
                        rows: formatData(categoriasData)
                    });
                }
                setLoading(false);

            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [paginaActual, registrosPorPag, anexo, nivel, numSubcategorias, busqueda, ordenarColumna, orden, navigate, urlPadre]);

    const formatData = (data) => {
        return data.map((row) => {
            // console.log("row",  row.numSubcategorias);

            
            return {
                id: row.Id,
                nombre: row.categoria.toLowerCase(),
                activa: row.activa,
                nivel: row.nivel,
                anexo: row.anexo,
                numSubcategorias: row.numSubcategorias,
                editar: row.id,
            };
        });
    };

    const header = [
        {
            id: 'categoria',
            numeric: false,
            disablePadding: true,
            label: 'Nombre',
        },
        {
            id: 'nivel',
            numeric: true,
            disablePadding: false,
            label: 'Nivel',
        },
        {
            id: 'anexo',
            numeric: true,
            disablePadding: false,
            label: 'Anexo',
        },
        {
            id: 'numSubcategorias',
            numeric: true,
            disablePadding: false,
            label: 'Subcategorias',
        },
        {
            id: 'modificar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];

    

    return (
        <>
            
            
                

                <CabeceraForm>
                    <Titulo
                        texto="CATEGORIAS"
                        convocatoria="true"
                        tituloTabla="true"
                    />
                </CabeceraForm>
                <EnhancedTable
                    data={data.rows}
                    header={header}
                    meta={data.meta}
                    selected={selected}
                    setSelected={setSelected}
                    eliminarTodoCategorias={eliminarTodoCategorias}
                    setEliminarTodoCategorias={setEliminarTodoCategorias}
                    eliminarCatSelect={eliminarCatSelect}
                    setEliminarCatSelect={setEliminarCatSelect}
                    requisitos={requisitos}
                    anexo={esAnexo}
                    numSubcategorias={numSubcategorias}
                    isLoading={loading}
                />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
`
export default GestorCategoriasConvocatoria;
